import module from 'empresa/module.js'
import template from './template.html'

export default class EmpresaCuentaDocumentosComponent {
  constructor ($api, EmpresaCuentaDocumentos) {
    this.$api = $api
    this.EmpresaCuentaDocumentos = EmpresaCuentaDocumentos
    this.idEmpresa = null
    this.idCuenta = null
    this.eliminando = null
    this.src = null
  }

  $onInit () {
    this.promise = this.EmpresaCuentaDocumentos.get(this.idEmpresa, this.idCuenta)
      .then((response) => (this.data = response.data))
  }

  agregar (data) {
    this.agregando = false

    if (data) {
      this.data.push(data)
    }
  }

  eliminar (data) {
    this.eliminando = null

    if (data) {
      this.data = this.data.filter((item) => item.id !== data.id)
    }
  }

  seleccionar (item) {
    this.src = this.$api.link('/api/empresa/cuenta/documento', {
      id_empresa: item.id_empresa,
      id_cuenta: item.id_cuenta,
      id_documento: item.id,
    })
  }
}

module.component('empresaCuentaDocumentos', {
  controller: EmpresaCuentaDocumentosComponent,
  template,
  bindings: {
    idEmpresa: '<',
    idCuenta: '<',
  },
})



// WEBPACK FOOTER //
// ./src/empresa/components/cuenta/documentos/component.js